import type { GroupBy } from '../types';

export type SystemGroupingPreference = 'BySystemName' | 'BySystemTypeName' | 'ByParameter';

export function toGroupBy(systemGroupingValue: string): GroupBy {
  if (systemGroupingValue === 'BySystemTypeName') {
    return 'SystemTypeName';
  }
  if (systemGroupingValue === 'ByParameter') {
    return 'Parameter';
  }
  return 'SystemName';
}

export function toSystemGroupingPreference(groupBy: GroupBy): SystemGroupingPreference {
  if (groupBy === 'SystemTypeName') {
    return 'BySystemTypeName';
  }
  if (groupBy === 'Parameter') {
    return 'ByParameter';
  }
  return 'BySystemName';
}

